export default __webpack_public_path__ + "static/media/GE.4944d603.svg";